<template>
  <v-form ref="exerciseForm" style="padding-top: 10px">
    <v-card :key="updater">
      <v-toolbar dark color="#0F1547">
        <v-toolbar-title style="color: white">Editer l'exercice {{ load.title }}</v-toolbar-title>
        <template v-slot:extension>
          <v-switch v-if="!load.advancedMode" v-model="load.advancedMode" label="Mode simplifié" inset></v-switch>
          <v-switch v-else v-model="load.advancedMode" label="Mode avancé" inset></v-switch>
        </template>

        <v-spacer></v-spacer>
      </v-toolbar>

      <v-card-text>
        <div class="md-layout">
          <!-- Title -->
          <div class="md-layout-item md-small-size-100 md-size-33">
            <v-text-field label="Titre" v-model="load.title" :rules="[rules.required, rules.counter]" counter maxlength="60"></v-text-field>
          </div>
          <!-- Exercise Type -->
          <div class="md-layout-item md-small-size-100 md-size-33 fit-content-radio flex-center">
            <v-radio-group v-model="load.exerciseType" label="Type" :rules="[rules.required]">
              <v-radio :value="ExerciseTypes.EXERCISE" label="Exercice"> </v-radio>
              <v-radio :value="ExerciseTypes.EVALUATION" label="Test(évaluation)"> </v-radio>
              <v-radio :value="ExerciseTypes.REFERENCE" label="Situation de référence"> </v-radio>
            </v-radio-group>
          </div>
          <!-- Destination -->
          <div class="md-layout-item md-small-size-100 md-size-33 flex-center">
            <v-radio-group column v-model="load.destinationType" label="Destination" v-on:change="changeDestination" :rules="[rules.required]">
              <v-radio :value="DestinationTypes.PUBLIC" label="Transversal"> </v-radio>
              <v-radio v-if="canChooseFederationDestinationType" :value="DestinationTypes.FEDERAL" label="Fédération" :disabled="!federations || !federations.length">
              </v-radio>
              <v-radio v-if="canChooseDisciplineDestinationType" :value="DestinationTypes.DISCIPLINE" label="Spécifique" :disabled="!disciplines || !disciplines.length">
              </v-radio>
              <v-radio v-if="canChooseCoachDestinationType" :value="DestinationTypes.COACH" label="Entraîneur" :disabled="!coaches || !coaches.length"> </v-radio>
            </v-radio-group>
          </div>

          <!-- Federations -->
          <div
            v-if="federations && federations.length && load != null && load.destinationType === DestinationTypes.FEDERAL"
            class="md-layout-item md-small-size-100 md-size-100 mb-5"
          >
            <v-select
              label="Fédération"
              :items="federations"
              item-text="name"
              item-value="id"
              v-model="load.federationId"
              :rules="[rules.required]"
              :disabled="federations && federations.length === 1"
            ></v-select>
          </div>

          <!-- Disciplines -->
          <div
            v-else-if="disciplines && disciplines.length && load != null && load.destinationType === DestinationTypes.DISCIPLINE"
            class="md-layout-item md-small-size-100 md-size-100 mb-5"
          >
            <v-select
              label="Discipline"
              :items="disciplines"
              item-text="name"
              item-value="id"
              v-on:change="changeDiscipline($event)"
              v-model="load.disciplineId"
              :rules="[rules.required]"
              :disabled="disciplines && disciplines.length === 1"
            ></v-select>
          </div>

          <!-- Coaches -->
          <div
            v-else-if="coaches && coaches.length && load != null && load.destinationType === DestinationTypes.COACH"
            class="md-layout-item md-small-size-100 md-size-100 mb-5"
          >
            <v-select
              label="Entraîneur"
              :items="coaches"
              item-text="email"
              return-object
              v-on:change="changeCoach($event)"
              v-model="load.coach"
              :rules="[rules.required]"
              :disabled="coaches && coaches.length === 1"
            ></v-select>
          </div>

          <template>
            <!-- Description -->
            <div class="md-layout-item md-size-100">
              <v-label>Description</v-label>
              <ckeditor :editor="editor" v-model="load.descriptionHtml" :config="editorConfig" />
            </div>
            <!-- Instructions -->
            <div class="md-layout-item md-size-100 mt-5">
              <v-label>Instructions</v-label>

              <ckeditor :editor="editor" v-model="load.instructionsHtml" :config="editorConfig" />
            </div>
            <!-- Realisation -->
            <div v-if="load.advancedMode" class="md-layout-item md-small-size-100 md-size-50 pt-5">
              <div class="md-layout-item md-size-100">
                <v-textarea label="Critères de réalisation" rows="2" v-model="load.realisation"></v-textarea>
              </div>
            </div>
            <!-- Prérequis -->
            <div v-if="load.advancedMode" class="md-layout-item md-small-size-100 md-size-50 pt-5">
              <div class="md-layout-item md-size-100">
                <v-textarea label="Prérequis" rows="2" v-model="load.prerequis"></v-textarea>
              </div>
            </div>
            <!-- Variables -->
            <div v-if="load.advancedMode" class="md-layout-item md-small-size-100 md-size-50 pt-5">
              <div class="md-layout-item md-size-100">
                <v-textarea label="Variables" rows="2" v-model="load.variables"></v-textarea>
              </div>
            </div>
            <!-- Experience Level -->
            <div v-if="load.advancedMode && load.disciplineId" class="md-layout-item md-small-size-100 md-size-50 pt-5">
              <div class="md-layout-item md-size-100">
                <v-select
                  v-model="load.experienceLevels"
                  item-value="id"
                  :items="disciplineExperienceLevels"
                  item-text="title"
                  chips
                  :label="experienceLevelCustomTitle"
                  multiple
                  outlined
                ></v-select>
              </div>
            </div>
            <!-- WorkForms -->
            <div v-if="load.disciplineId" class="md-layout-item md-small-size-100 md-size-50 pt-5">
              <div class="md-layout-item md-size-100">
                <v-select
                  v-model="load.workForms"
                  item-value="id"
                  :items="disciplineWorkForms"
                  item-text="title"
                  chips
                  :label="workFormCustomTitle"
                  multiple
                  outlined
                ></v-select>
              </div>
            </div>
            <!-- Skills -->
            <div
              v-if="load.advancedMode && load.disciplineId && disciplineSkills.items && disciplineSkills.items.length > 0"
              class="md-layout-item md-small-size-100 md-size-50"
            >
              <v-label>{{ skillCustomTitle }}</v-label>

              <v-treeview v-model="load.skills" selectable item-key="id" item-text="title" :items="disciplineSkills.items" selection-type="leaf" transition></v-treeview>
            </div>
            <!-- Materiel -->
            <div class="md-layout-item md-size-100 mt-5">
              <v-label>Matériel</v-label>

              <ckeditor :editor="editor" v-model="load.materielHtml" :config="editorConfig" placeholder="Type some text..." />
            </div>
          </template>
        </div>
      </v-card-text>
    </v-card>
  </v-form>
</template>
<script>
import ClassicEditor from "@/plugins/ckeditor5/build/ckeditor";
import { getAllCurrentUserCoachesAsync } from "@/api/teamApi";
import { getAllCurrentUserFederationsAsync } from "@/api/federationsApi";
import { getDisciplineAsync, getAllCurrentUserDisciplinesAsync } from "@/api/disciplinesApi";
import { getExperienceLevelForDisciplineAsync } from "@/api/experienceLevelApi";
import { getWorkFormForDisciplineAsync } from "@/api/workFormApi";
import { getSkillsForDisciplineAsync } from "@/api/skillApi";
import store from "@/store";
import { DestinationType, ExerciseType } from "@/models/enums";
import PermissionsService from "@/services/PermissionsService";

export default {
  name: "exercise-form",

  props: {
    dataBackgroundColor: {
      type: String,
      default: "",
    },
    load: Object,
    isPrinting: {
      default: true,
      type: Boolean,
    },
  },

  computed: {
    // Needed to allow federation managers to select federation destination
    canChooseFederationDestinationType() {
      return PermissionsService.FederationsPermissionsService.canManageOwnFederation;
    },
    // Needed to allow discipline managers to select discipline destination
    canChooseDisciplineDestinationType() {
      return PermissionsService.DisciplinesPermissionsService.canManageOwnDiscipline || this.canChooseFederationDestinationType;
    },
    // Needed to allow coaches to select coach destination
    canChooseCoachDestinationType() {
      return PermissionsService.TeamsPermissionsService.canManageOwnTeam || this.canChooseDisciplineDestinationType;
    },
  },

  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {
        toolbar: [
          "undo",
          "redo",
          "|",
          "bold",
          "italic",
          "underline",
          "|",
          "alignment:left",
          "alignment:center",
          "alignment:right",
          "alignment:justify",
          "|",
          "bulletedList",
          "numberedList",
          "|",
          "indent",
          "outdent",
        ],
      },
      dialog: false,
      advance: false,
      rules: {
        required: (value) => !!value || "Requis.",
        counter: (value) => (value ? value.length <= 60 : "Max 60 caractères"),
      },
      disciplines: [],
      federations: [],
      coaches: [],      
      updater: 0,
      disciplineExperienceLevels: [],
      experienceLevelCustomTitle: "",
      disciplineWorkForms: [],
      workFormCustomTitle: "",
      disciplineSkills: [],
      skillCustomTitle: "",
      DestinationTypes: DestinationType,
      ExerciseTypes: ExerciseType,
    };
  },

  async mounted() {
    // List of federations if admin or super, only one federation if federation manager, discipline manager or coach
    this.federations = await getAllCurrentUserFederationsAsync();    
    // List of disciplines if admin, super or federation manager, only one if discipline manager or coach
    this.disciplines = await getAllCurrentUserDisciplinesAsync();
    // List of coaches if admin, super, federation manager or discipline manager, only one if coach
    this.coaches = await getAllCurrentUserCoachesAsync();

    this.updater++;

    // If we are openning in edit mode
    if (this.load && this.load.disciplineId) {
      await this.changeDiscipline();
    }
    // Else we are openning in create mode
    else {
      // Set destinationType radio button default value to Public
      this.load.destinationType = DestinationType.PUBLIC;
      this.load.defaultFederationId = this.federations[0].id;

      // Set exerciseType radio button default value to Exercise
      this.load.exerciseType = ExerciseType.EXERCISE;
    }

    // Force the refresh a the v-treeview for skills (doesn't work if not reasigned here)
    if (this.load.selectedSkills) {
      this.load.skills = [...this.load.selectedSkills];
    }
  },

  methods: {
    print() {
      window.print();
    },

    // Event on destinationType radio value changed
    async changeDestination(selectedDestinationType) {
      // If we selected something else than FEDERAL, we wanna empty FEDERATION RELATED DATA
      if (selectedDestinationType !== DestinationType.FEDERAL) {
        this.load.federationId = null;
      }
      // Else we wanna auto select first FEDERATION id if there is only one
      else {
        // if we only have one federation in the array, we wanna select the first one
        if (this.federations && this.federations.length === 1) {
          this.load.federationId = this.federations[0].id;
        }
      }

      // If we selected DISCIPLINE
      if (selectedDestinationType === DestinationType.DISCIPLINE) {
        // if we only have one discipline in the array, we wanna select the first one
        if (this.disciplines && this.disciplines.length === 1) {
          this.load.disciplineId = this.disciplines[0].id;
          await this.changeDiscipline();
        }
      }

      // If we selected something else than COACH, we wanna empty COACH RELATED DATA
      if (selectedDestinationType !== DestinationType.COACH) {
        this.load.coachId = null;
        this.load.coach = null;

        // Empty experience levels
        this.load.disciplineExperienceLevels = [];
        this.load.experienceLevels = [];
        this.load.exerciseExperienceLevels = [];

        // Empty work forms
        this.load.disciplineWorkForms = [];
        this.load.workForms = [];
        this.load.exerciseWorkForms = [];

        // Empty skills
        this.load.disciplineSkills = [];
        this.load.skills = [];
        this.load.exerciseSkills = [];
      }
      // Else we wanna auto select first COACH id if there is only one
      else {
        // if we only have one coach in the array, we wanna select the first one
        if (this.coaches && this.coaches.length === 1) {
          this.load.coachId = this.coaches[0].id;
          this.load.coach = this.coaches[0];
          this.load.disciplineId = this.coaches[0].coachParentDisciplineId;
          await this.changeDiscipline();
        }
      }

      // Unselect discipline and related if not discipline or coach
      if (selectedDestinationType !== DestinationType.DISCIPLINE && selectedDestinationType !== DestinationType.COACH) {
        this.load.disciplineId = null;

        // Empty experience levels
        this.load.disciplineExperienceLevels = [];
        this.load.experienceLevels = [];
        this.load.exerciseExperienceLevels = [];

        // Empty work forms
        this.load.disciplineWorkForms = [];
        this.load.workForms = [];
        this.load.exerciseWorkForms = [];

        // Empty skills
        this.load.disciplineSkills = [];
        this.load.skills = [];
        this.load.exerciseSkills = [];
      }
    },

    // On change selected discipline, we wanna get related info
    async changeDiscipline(discipline) {
      await this.getDisciplineForCustomLabels();
      await this.getExperienceLevelsForDiscipline();
      await this.getWorkFormsForDiscipline();
      await this.getSkillsForDiscipline();

      this.updater++;
    },

    // On change selected coach, store the selected coach
    // Also, we wanna get related discipline info
    async changeCoach(coach) {
      this.load.coachId = coach.id;
      this.load.coach = coach;
      // Update the current discipline id based on the newly selected coach's parent discipline
      // Needed to get discipline related info
      this.load.disciplineId = coach.coachParentDisciplineId;

      await this.changeDiscipline();
    },

    //Get the list of Experience Levels
    async getExperienceLevelsForDiscipline() {
      this.disciplineExperienceLevels = await getExperienceLevelForDisciplineAsync(this.load.disciplineId);
      if (!this.disciplineExperienceLevels) {
        store.dispatch("setSnackbar", {
          title: "Erreur",
          text: "Impossible de récupérer les niveaux d'experiences de la discipline auprès du serveur",
          status: "error",
          timeout: 5000,
        });
      }
    },

    //Get the list of WorkForms
    async getWorkFormsForDiscipline() {
      this.disciplineWorkForms = await getWorkFormForDisciplineAsync(this.load.disciplineId);
      if (!this.disciplineWorkForms) {
        store.dispatch("setSnackbar", {
          title: "Erreur",
          text: "Impossible de récupérer les formes de travail de la discipline auprès du serveur",
          status: "error",
          timeout: 5000,
        });
      }
    },

    //Get the list of Skills
    async getSkillsForDiscipline() {
      this.disciplineSkills = await getSkillsForDisciplineAsync(this.load.disciplineId);
      if (!this.disciplineSkills) {
        store.dispatch("setSnackbar", {
          title: "Erreur",
          text: "Impossible de récupérer les compétences de la discipline auprès du serveur",
          status: "error",
          timeout: 5000,
        });
      }
    },

    // Get the current discipline to use the custom Experience Level title
    async getDisciplineForCustomLabels() {
      if (this.load && this.load.disciplineId) {
        this.currentDiscipline = await getDisciplineAsync(this.load.disciplineId);

        if (!this.currentDiscipline) {
          store.dispatch("setSnackbar", {
            title: "Erreur",
            text: "Impossible de récupérer la discipline auprès du serveur",
            status: "error",
            timeout: 5000,
          });
        } else {
          // Experience Level
          this.experienceLevelCustomTitle = this.currentDiscipline.experienceLevelCustomTitle ? this.currentDiscipline.experienceLevelCustomTitle : "Niveaux de pratique";

          // WorkForm
          this.workFormCustomTitle = this.currentDiscipline.workFormCustomTitle ? this.currentDiscipline.workFormCustomTitle : "Formes de travail";

          // Skill
          this.skillCustomTitle = this.currentDiscipline.skillCustomTitle ? this.currentDiscipline.skillCustomTitle : "Compétences";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable {
  min-height: 100px !important;
  max-height: 400px !important;
}

::v-deep .v-radio {
  .v-label {
    margin-bottom: 0px !important;
  }
}

::v-deep .v-card__text {
  .v-input--selection-controls {
    margin-top: 0px !important;
    padding-top: 10px !important;
  }
}

::v-deep .v-toolbar__extension {
  .v-label {
    padding-top: 10px;
    border: none !important;
  }
}
</style>
